import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const addingOrderApi = createApi({
	reducerPath: 'addingOrderApi',
	baseQuery: customBaseQuery,
	refetchOnFocus: true,
	refetchOnReconnect: true,
	tagTypes: ['adding-order'],
	endpoints: (builder) => ({

		// POST /api/adding-order/create
		createAddingOrder: builder.mutation({
			query: ({ data }) => ({
				url: '/create',
				method: 'POST',
				body: data,
				schema: 'steam',
				prefix: 'adding-order',
			}),
			invalidatesTags: ['adding-order'],
		}),

		// GET /api/adding-order/all
		getAllAddingOrders: builder.query({
			query: ({ params = {} }) => ({
				url: '/all',
				method: 'GET',
				params,
				schema: 'steam',
				prefix: 'adding-order',
			}),
			providesTags: ['adding-order'],
		}),

		// GET /api/adding-order/:id
		getAddingOrderById: builder.query({
			query: ({ id }) => ({
				url: `/${id}`,
				method: 'GET',
				schema: 'steam',
				prefix: 'adding-order',
			}),
			providesTags: (result, error, { id }) => [{ type: 'adding-order', id }],
		}),

		// DELETE /api/adding-order/:id
		deleteAddingOrderById: builder.mutation({
			query: ({ id }) => ({
				url: `/${id}`,
				method: 'DELETE',
				schema: 'steam',
				prefix: 'adding-order',
			}),
			invalidatesTags: ['adding-order'],
		}),

		// PUT /api/adding-order/:id
		updateAddingOrder: builder.mutation({
			query: ({ id, data }) => ({
				url: `/${id}`,
				method: 'PUT',
				body: data,
				schema: 'steam',
				prefix: 'adding-order',
			}),
			invalidatesTags: (result, error, { id }) => [{ type: 'adding-order', id }],
		}),

	}),
});

export const {
	useCreateAddingOrderMutation,
	useGetAllAddingOrdersQuery,
	useGetAddingOrderByIdQuery,
	useDeleteAddingOrderByIdMutation,
	useUpdateAddingOrderMutation,
} = addingOrderApi;